import React, { useMemo } from 'react';
import "./bakeryTasksItemStyles.scss"
import ButtonHint from "../../../../components/Buttons/buttonHint/ButtonHint";
import AngrySmile from "./img/angry_smile.svg";
import StupidSmile from "./img/stupid _smile.svg"
import HappySmile from "./img/happy_smile.svg"
import {HandySvg} from "handy-svg";

const BakeryTasksItem = ({ data, onAddProduct }) => {

    const progress = useMemo(() => {
        if (!data) return 0;
        const current = data.current_quantity || 0;
        const plane = data.plane_quantity || 1;
        return (current / plane) * 100;
    }, [data?.current_quantity, data?.plane_quantity]);

    const getProgressColor = (progress) => {
        if (progress < 50) return '#FE3C40';
        if (progress >= 50 && progress < 80) return '#F6BC26';
        return '#46C73F';
    };

    const getSmile = (progress) => {
        if (progress < 50) return AngrySmile;
        if (progress >= 50 && progress < 80) return StupidSmile;
        return HappySmile;
    };

    const progressColor = getProgressColor(progress);
    const smileIcon = getSmile(progress);

    const handleProduce = () => {
        if (onAddProduct) {
            onAddProduct(data);
        }
    };

    return (
        <div className="bakery-task-item">
            <div className="bakery-task-item__header">
                <div className="bakery-task-item__name">{data?.goods?.name}</div>
                <HandySvg
                    className="bakery-task-item__smile"
                    src={smileIcon}
                />
            </div>

            <div className="bakery-task-item__content">
                <div className="bakery-task-item__body">
                    <div className="bakery-task-item__leftover">
                        Остаток: {data?.goods_leftover !== null && data?.goods_leftover !== undefined
                        ? `${data.goods_leftover} ${data.goods_leftover === 1 ? 'шт' : 'шт'}`
                        : "нет"}
                    </div>

                    <div className="bakery-task-item__quantity">
                        Произведено: {data?.current_quantity || 0} из {data?.plane_quantity || 0}
                    </div>
                </div>

                <div className="bakery-task-item__progress-container">
                    <div className="bakery-task-item__progress-bar">
                        <div
                            className="bakery-task-item__progress-fill"
                            style={{
                                width: `${Math.min(progress, 100)}%`,
                                backgroundColor: progressColor
                            }}
                        />
                    </div>

                    <ButtonHint
                        text={"Провести изготовление"}
                        className="button_add_bakery-product"
                        funck={handleProduce}
                    />
                </div>
            </div>
        </div>
    );
};

export default BakeryTasksItem;